'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var EditToolbar = React.createClass({
  render: function () {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        border: '1px solid #000',
        backgroundColor:'#fff'
      }}>
        <img src={assetsHelper.getComponentAsset('editToolbar')} alt=""/>
      </div>
    );
  }
});

module.exports = EditToolbar;



// WEBPACK FOOTER //
// ./src/views/Components/EditToolbar.jsx